import React from "react";
import PropTypes from "prop-types";
import style from "./Container.module.css";

type ContainerProps = {
  children?: React.ReactNode;
  large?: boolean;
  alignItems?: boolean;
  justifyContent?: boolean;
  containerStyle?: React.CSSProperties;
  containerClass?: string;
};

const Container = ({
  children,
  large = false,
  alignItems,
  justifyContent,
  containerStyle,
  containerClass,
}: ContainerProps) => (
  <div
    className={[large ? style.large : style.normal, containerClass].join(" ")}
    style={{
      ...containerStyle,
      alignItems: alignItems ? "center" : "none",
      justifyContent: justifyContent ? "center" : "none",
    }}
  >
    {children}
  </div>
);

export default Container;
